import React, { useEffect, useState } from "react";
import "./App.css";
import santaLogo from "./images/santa-logo-1.jpeg";
import PrivacyPolicy from "./PrivacyPolicy";
import DataDeletion from "./DataDeletion";

function App() {
  const getCurrentPage = () => {
    const hash = window.location.hash;
    if (hash === "#privacy") return "privacy";
    if (hash === "#data-delete") return "delete";
    return "home";
  };

  const [page, setPage] = useState(getCurrentPage());

  useEffect(() => {
    const handleHashChange = () => {
      setPage(getCurrentPage());
    };

    window.addEventListener("hashchange", handleHashChange);
    return () => window.removeEventListener("hashchange", handleHashChange);
  }, []);

  const goHome = () => {
    window.location.hash = "";
    setPage("home");
  };

  if (page === "privacy") {
    return <PrivacyPolicy onBack={goHome} />;
  }

  if (page === "delete") {
    return <DataDeletion onBack={goHome} />;
  }

  return (
    <div className="landing-container">
      <header className="landing-header">
        <img src={santaLogo} alt="Santa Thadeu Logo" className="landing-logo" />
        <div className="landing-title-group">
          <h1 className="landing-title">
            Santa <span className="highlight">Thadeu</span>
          </h1>
          <h2 className="landing-subtitle">Health Services</h2>
        </div>
      </header>
      <main className="landing-main">
        <section className="landing-intro">
          <p>
            Welcome to Santa Thadeu, your trusted clinic for quality healthcare.
            Our team includes medical doctors, dentists, and psychologists,
            providing comprehensive care for you and your family.
          </p>
        </section>
        <section className="landing-branches">
          <div className="branch-card">
            <h3>Sentosa Branch</h3>
            <p>6 Waverly Close, Sentosa, Mabelreign, Harare, Zimbabwe</p>
            <p>
              <strong>Phone/WhatsApp:</strong>{" "}
              <a href="tel:+263718355580">0718 355 580</a>
            </p>
            <button
              className="chat-btn"
              onClick={() =>
                window.open("https://wa.me/263718355580", "_blank")
              }
            >
              Chat with Sentosa team
            </button>
          </div>
          <div className="branch-card">
            <h3>Queensdale Branch</h3>
            <p>137 Chiremba Road, Queensdale, Harare, Zimbabwe</p>
            <p>
              <strong>Phone/WhatsApp:</strong>{" "}
              <a href="tel:+263788971892">0788 971 892</a>
            </p>
            <button
              className="chat-btn"
              onClick={() =>
                window.open("https://wa.me/263788971892", "_blank")
              }
            >
              Chat with Queensdale team
            </button>
          </div>
        </section>
        <section className="landing-contact">
          <a
            className="whatsapp-channel"
            href="https://whatsapp.com/channel/0029Vb5GbvM5PO12WSqnGE13"
            target="_blank"
            rel="noopener noreferrer"
          >
            Follow us on WhatsApp
          </a>
          <p className="email-contact">
            Or email us at{" "}
            <a href="mailto:community@santathadeu.co.zw">
              community@santathadeu.co.zw
            </a>
          </p>
        </section>
      </main>
      <footer className="landing-footer">
        <p>
          &copy; {new Date().getFullYear()} Santa Thadeu Health Services. All
          rights reserved.
        </p>
        <div className="footer-links">
          <a className="privacy-link" href="#privacy">
            Privacy Policy
          </a>
          <a className="privacy-link" href="#data-delete">
            Delete My Data
          </a>
        </div>
      </footer>
    </div>
  );
}

export default App;
